import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'awair-index-dot',
  templateUrl: './index-dot.component.html',
  styleUrls: ['./index-dot.component.scss']
})

export class IndexDotComponent implements OnInit {
  // Default color to disconnected gray
  @Input() color: string = '#CDD3D8';
  @Input() width: number = 10;
  @Input() height: number = 10;

  constructor() {
  }

  ngOnInit() {
  }
}
